"use client"
import SectionPage from "@/components/common/section-page";
import SectionTitle from "@/components/common/section-title";
import {OnlyImageBgCard, PaveScaleCard} from "@/components/common/pave-scale-card";

export default function VivezVotreExperienceSection() {
    return (
        <div className={"bg-white py-8"}>
            <SectionPage sectionType={"lg"}>
                <SectionTitle title={"Vivez votre expérience"} className={"text-bleu-marine text-center"} />
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6 mb-6">
                    <PaveScaleCard title={"Nature, Biodiversité et Activités de plein air"} buttonLabel={"Consulter"} className={"h-[400px]"} link="/nature" />
                    <OnlyImageBgCard imageSrc={"/images/vivez-votre-experience/vivez-votre-experience01.jpg"} className={"h-[400px]"} />
                    <PaveScaleCard title={"Soleil et Plage"} buttonLabel={"Consulter"} className={"h-[400px]"} link="/soleil-plage" />
                    <PaveScaleCard title={"Art de vivre et Gastronomie d'ici"} buttonLabel={"Consulter"} className={"h-[400px]"} link="/art-de-vivre-gastro" />
                    <OnlyImageBgCard imageSrc={"/images/vivez-votre-experience/vivez-votre-experience02.jpg"} className={"h-[400px]"} />
                    <PaveScaleCard title={"Culture, Patrimoine et Art"} buttonLabel={"Consulter"} className={"h-[400px]"} link="/culture-patrimoine-art" />
                </div>
            </SectionPage>
        </div>
    )
}
